jQuery(document).ready(function($) {
    $('.single-swiper-fade').each(function() {
        const $swiperContainer = $(this);
        const $wrapper = $swiperContainer.closest('.container');
        
        new Swiper(this, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 600,
            loop: true,
            autoplay: true,
            navigation: {
                nextEl: $wrapper.find('.swiper-next')[0],
                prevEl: $wrapper.find('.swiper-prev')[0],
            },
        });
    });
});